// Lightweight client-side usage analytics: page views + dwell time.
// Feature usage ("used what") is captured server-side via API middleware.
import { API } from "@/lib/api";

const SKEY = "ciao_sid";

export function getSessionId() {
  let sid = sessionStorage.getItem(SKEY);
  if (!sid) {
    try {
      sid = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
    } catch (e) {
      sid = String(Date.now()) + Math.random().toString(16).slice(2);
    }
    sessionStorage.setItem(SKEY, sid);
  }
  return sid;
}

let queue = [];

export function enqueue(ev) {
  queue.push({ ...ev, session_id: getSessionId(), ts: new Date().toISOString() });
}

function getToken() {
  return localStorage.getItem("ciao_token");
}

// Sends queued events. Uses fetch+keepalive so it also works during page unload
// while still allowing the Authorization header (sendBeacon cannot set headers).
export function flush() {
  if (!queue.length) return;
  const events = queue;
  queue = [];
  const token = getToken();
  try {
    fetch(`${API}/analytics/track`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ events }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* best-effort; ignore */
  }
}
